import { ClickEvent } from "@mcleod/components";
import { Navigation } from "@mcleod/core";
import { AutogenLayoutTransmissionStatusQuickInfo } from "./autogen/AutogenLayoutTransmissionStatusQuickInfo";

export class TransmissionStatusQuickInfo extends AutogenLayoutTransmissionStatusQuickInfo {
    
    private _transmissionStatusURL = "lme/datafusion/TransmissionControlList?id="


    openClassicStatus(event: ClickEvent): void {
        const id = this.sourceEdiLog.activeRow.get("id");
        Navigation.navigateTo(this.tranmissionStatusURL + id, { newTab: true });
    }

    get tranmissionStatusURL() {
        return this._transmissionStatusURL;
    }
}